import React, { useState } from "react";
import { Link } from "react-router-dom";
import Site2Layout from "./Site2Layout";

const SERVICES = [
  {
    icon: "📊",
    title: "Marketing — New Territories & Brands",
    desc: "In-depth market understanding of both domestic and international markets. We help you identify, enter, and win in new market segments with precision.",
  },
  {
    icon: "🔎",
    title: "Market Potential Analysis",
    desc: "Choosing the right markets and market segments, and analysing potential in the chosen segments. Data-driven sizing to direct your resources.",
  },
  {
    icon: "🏛️",
    title: "Liaisoning with Government Agencies",
    desc: "We provide expert liaisoning services with government agencies to ensure seamless execution of new projects, approvals, and regulatory compliance.",
  },
  {
    icon: "👥",
    title: "Manpower Selection",
    desc: "A comprehensive approach to hiring the right talent — finding individuals who fit both technical and cultural requirements of your business.",
  },
  {
    icon: "✅",
    title: "Customer Approvals",
    desc: "Our Customer Approval service ensures your customers are fully satisfied by gathering feedback, addressing concerns, and driving customer loyalty.",
  },
  {
    icon: "🚀",
    title: "Test Marketing",
    desc: "A strategic approach to launching new products or services — gauge market demand, identify challenges, and refine your offerings before full rollout.",
  },
];

const Site2Services = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <Site2Layout
      tag="What We Do"
      title="Services Built for Real Growth"
      subtitle="From first insight to final execution, we cover every stage of your market development journey."
    >
      <section style={{ backgroundColor: "#ffffff" }} className="py-20 px-6">
        <div className="max-w-4xl mx-auto space-y-4">
          {SERVICES.map((s, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                style={{
                  background: isOpen ? "rgba(72, 31, 87, 0.03)" : "#ffffff",
                  border: isOpen ? "1px solid #481F57" : "1px solid #e5e7eb",
                  transition: "all 0.3s ease",
                }}
                className="rounded-2xl overflow-hidden shadow-sm hover:shadow-md text-left"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                >
                  <div className="flex items-center gap-4">
                    <span
                      style={{ background: "linear-gradient(135deg,#481F57,#6B3080)" }}
                      className="w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0 text-white"
                    >
                      {s.icon}
                    </span>
                    <span className="text-[#481F57] font-bold text-base sm:text-lg leading-snug">
                      {s.title}
                    </span>
                  </div>
                  <span
                    style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", color: "#481F57" }}
                    className="text-2xl flex-shrink-0 ml-4 transition-transform duration-300 font-semibold"
                  >
                    ⌄
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6">
                    <div style={{ borderLeft: "3px solid #481F57" }} className="pl-4">
                      <p className="text-gray-700 text-base leading-8">{s.desc}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="max-w-4xl mx-auto mt-16 text-center">
          <div
            style={{
              background: "linear-gradient(135deg, #f5f3ff, #fae8ff)",
              border: "1px solid rgba(72, 31, 87, 0.15)",
            }}
            className="rounded-2xl p-10"
          >
            <h2 className="text-2xl lg:text-3xl font-extrabold text-[#481F57] mb-4">
              Ready to explore how we can help?
            </h2>
            <p className="text-gray-600 mb-8 text-base max-w-xl mx-auto leading-7">
              Are you looking for a trusted partner to help you set up your business in India?
              An Indian company wanting to grow globally? We are your partners.
            </p>
            <Link
              to="/contact"
              style={{ background: "linear-gradient(135deg,#481F57,#6B3080)" }}
              className="inline-block text-white font-bold px-8 py-4 rounded-full hover:opacity-90 transition-opacity shadow-md"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </Site2Layout>
  );
};

export default Site2Services;
